import React from "react";
import { amenities } from "../../data/mockData";
import { Check } from "lucide-react";
import useInView from "../../hooks/useInView";

const FacilitiesSection = () => {
  const [amenitiesRef, amenitiesInView] = useInView();

  return (
    <section ref={amenitiesRef} className="py-24 bg-[#1B2A4A]">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
            Facilities
          </span>
          <h2 className="text-4xl font-serif font-bold text-white mt-3">
            Club Amenities
          </h2>
        </div>
        <div
          className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 transition-all duration-700 ${
            amenitiesInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {amenities.map((amenity) => (
            <div
              key={amenity}
              className="flex items-center gap-3 p-4 bg-white/5 rounded-lg hover:bg-white/10 transition-colors"
            >
              <Check size={16} className="text-[#C9A96E] shrink-0" />
              <span className="text-white/80 text-sm">{amenity}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { FacilitiesSection };
